import { IconButton, SortDirection, SortDropdownMenu } from '@melio/penny';

import { usePayDashboardMobileSort } from './usePayDashboardMobileSort';

export const MobileSortMenu = ({
  items,
  onSortChange,
}: {
  items: { label: string; cellId: string; defaultSortOrder: SortDirection }[];
  onSortChange?: VoidFunction;
}) => {
  const { sortMenuItems, isMenuOpen, setIsMenuOpen, selectedItemIndex } = usePayDashboardMobileSort({
    sortableItems: items,
    onSortChange,
  });

  return (
    <SortDropdownMenu
      items={sortMenuItems}
      selectedItemIndex={selectedItemIndex}
      sortDirection={sortMenuItems[selectedItemIndex]?.sortDirection}
      trigger={<IconButton icon="sort" variant="naked" aria-label="icon-button-sort" />}
      onOpenChange={setIsMenuOpen}
      isOpen={isMenuOpen}
    />
  );
};
